import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

// Page Components
import DashboardPage from './pages/DashboardPage';
import DirectoryPage from './pages/DirectoryPage';
import DocumentsPage from './pages/DocumentsPage';
import HRPage from './pages/HRPage';
import ProfilePage from './pages/ProfilePage';
import EventCalendarPage from './pages/EventCalendarPage';
import InnovationPage from './pages/InnovationPage';
import AdministrativePage from './pages/AdministrativePage';
import InventoryPage from './pages/InventoryPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import ChatWidget from './components/ChatWidget';
import SurveyPage from './pages/SurveyPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import BasvurularPage from './pages/BasvurularPage';
import YeniCalisanPage from './pages/YeniCalisanPage';
import TumCalisanlarPage from './pages/TumCalisanlarPage';
import IdariIslerTaleplerimPage from './pages/IdariIslerTaleplerimPage';
import IdariIslerIstatistiklerPage from './pages/IdariIslerIstatistiklerPage';
import ZimmetListesiPage from './pages/ZimmetListesiPage';
import YeniZimmetPage from './pages/YeniZimmetPage';
import ZimmetRaporlariPage from './pages/ZimmetRaporlariPage';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/giris" element={<LoginPage />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Sidebar />
              <Header />
              <div className="main">
                <div className="main-content">
                  <Routes>
                    <Route path="/anasayfa" element={<DashboardPage />} />
                    <Route path="/duyurular" element={<AnnouncementsPage />} />
                    <Route path="/personel-rehberi" element={<DirectoryPage />} />
                    <Route path="/dokuman-merkezi" element={<DocumentsPage />} />
                    <Route path="/insan-kaynaklari" element={<HRPage />} />
                    <Route path="/basvurular" element={<BasvurularPage />} />
                    <Route path="/yeni-calisan" element={<YeniCalisanPage />} />
                    <Route path="/tum-calisanlar" element={<TumCalisanlarPage />} />
                    <Route path="/profil" element={<ProfilePage />} />
                    <Route path="/etkinlik-takvimi" element={<EventCalendarPage />} />
                    <Route path="/anketler" element={<SurveyPage />} />
                    <Route path="/inovasyon-oneri" element={<InnovationPage />} />
                    <Route path="/idari-isler" element={<AdministrativePage />} />
                    <Route path="/idari-isler-talepler" element={<IdariIslerTaleplerimPage />} />
                    <Route path="/idari-isler-istatistikler" element={<IdariIslerIstatistiklerPage />} />
                    <Route path="/zimmet-yonetimi" element={<InventoryPage />} />
                    <Route path="/zimmet-listesi" element={<ZimmetListesiPage />} />
                    <Route path="/yeni-zimmet" element={<YeniZimmetPage />} />
                    <Route path="/zimmet-raporlari" element={<ZimmetRaporlariPage />} />
                  </Routes>
                </div>
              </div>
              
              <div className="overlay"></div>
              <ChatWidget />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 